export default function SysName() {
  return "Sistema Merlin";
}
